const initialState = {
    "paso": 0,
    "contrasena": "",
    "confirmarContrasena": "",
    "hash": ""
}

export function modificarRdc(state = initialState, action) {
    
    switch (action.type) {
        case "MODIFICAR_PASO_SIGUIENTE": 
            return {...state,
                "paso": state.paso + 1
            };
        case "MODIFICAR_PASO_ANTERIOR":
        	return {...state,
        		"paso": state.paso - 1
        	};
        case "MODIFICAR_SET_CONTRASENA":
            return {...state,
                "contrasena": action.contrasena
            };
        case "MODIFICAR_SET_CONTRASENA":
            return {...state,
                "confirmarContrasena": action.confirmacion
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/modificar/reducer.js